import React, { Component } from 'react'
import Styles from '../sass/layout/Header.module.sass'

class Nav extends Component {
  render(){
    return (
      <div className={Styles.header}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className={Styles.logo}>Fahaddevs</div>
            <ul className={Styles.nav}>
              <li className={Styles.nav__item}>
                <a href="#0" className={Styles.nav__link}>Home</a></li>
              <li className={Styles.nav__item}>
                <a href="#0" className={Styles.nav__link}>About</a>
              </li>
              <li className={Styles.nav__item}>
                <a href="#0" className={Styles.nav__link}>Portfolio</a>
                </li>
              <li className={Styles.nav__item}>
                <a href="#0" className={Styles.nav__link}>Contact</a>
                </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default Nav